import { useStoreActions } from '~/store/hooks';
import { IGetClientRequestPayload } from '~/store/client/types';
import { useApiRequest } from '~/hooks/api';
import { IMedicaidPlan } from '~/services/api/medicaidPlan/types';

interface IUseActiveMedicaidPlanParams extends IGetClientRequestPayload {
  enabled: boolean;
}

interface IUseActiveMedicaidPlanResult {
  plan: IMedicaidPlan | null;
  isLoading: boolean;
}

const useActiveMedicaidPlan = ({
  enabled,
  ...requestInfo
}: IUseActiveMedicaidPlanParams): IUseActiveMedicaidPlanResult => {
  const onGetMedicaidPlan = useStoreActions(actions => actions.client.onGetMedicaidPlan);

  const { isLoading, data: plan } = useApiRequest(() => onGetMedicaidPlan(requestInfo), {
    enabled,
    initialLoading: true,
    dependencies: [requestInfo.clinicId, requestInfo.teamId, requestInfo.clientId],
  });

  if (!enabled) return { plan: null, isLoading: false };
  if (isLoading || !plan) return { plan: null, isLoading };

  return { plan, isLoading: false };
};

export default useActiveMedicaidPlan;
